/**************************************************************************************************/
/*   File: /src/app/shared/enums/error.message.enum.ts                                            */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Thursday February 21st 2019                                                    */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed Aug 07 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * The messages enum
 */
export enum Messages {
    /**
     * All ambititi loading fail error
     */
    ALL_AMBITI_FAIL = 'error_allAmbitiFail',
    /**
     * Ambiti loading fail error
     */
    AMBITI_FAIL = 'error_ambitiFail',
    /**
     * Authorize accepted message
     */
    AUTHORIZE_ACCEPTED = 'error_authorizeAccepted',
    /**
     * Cannot contact authorize service error
     */
    AUTHORIZE_CANNOT_CONTACT = 'error_authorizeCannotContact',
    /**
     * Authorize pending message
     */
    AUTHORIZE_PENDING = 'error_authorizePending',
    /**
     * Authorize rejected message
     */
    AUTHORIZE_REJECTED = 'error_authorizeRejected',
    /**
     * Authorize requested message
     */
    AUTHORIZE_REQUEST = 'error_authorizeRequest',
    /**
     * Authorize revoke message
     */
    AUTHORIZE_REVOKE = 'error_authorizeRevoke',
    /**
     * Error requesting check dossier status
     */
    CANNOT_CHECK_DOSSIER_STATUS = 'error_cannotCheckDossierStatus',
    /**
     * Cannot contact server message
     */
    CANNOT_CONTACT_SERVER = 'error_cannotContactServer',
    /**
     * Cannot create dossier message
     */
    CANNOT_CREATE_DOSSIER = 'error_cannotCreateDossier',
    /**
     * Cannot create authorize request error
     */
    CANNOT_CREATE_REQUEST = 'error_cannotCreateRequest',
    /**
     * Cannot delete dossier
     */
    CANNOT_DELETE_DOSSIER = 'error_cannotDeleteRequest',
    /**
     * Cannot load dossier error
     */
    CANNOT_LOAD_DOSSIER = 'error_cannotLoadDossier',
    /**
     * Cannot load plan types message
     */
    CANNOT_LOAD_PLAN_TYPES = 'error_cannotLoadPlanTypes',
    /**
     * Cannot load public documents
     */
    CANNOT_LOAD_PUBLIC_DOCUMENT = 'error_cannotLoadPublicDocument',
    /**
     * Cannot remove file message
     */
    CANNOT_REMOVE_FILE = 'error_cannotRemoveFile',
    /**
     * Cannot send dossier
     */
    CANNOT_SEND_DOSSIER = 'error_cannotSendDossier',
    /**
     * Cannot update spatial
     */
    CANNOT_UPDATE_SPATIAL = 'error_cannotUpdateSpatial',
    /**
     * Cannot update other
     */
    CANNOT_UPDATE_OTHER = 'error_cannotUpdateOther',
    /**
     * Cannot update regulations
     */
    CANNOT_UPDATE_REGULATION = 'error_cannotUpdateRegulations',
    /**
     * Cannot upload geometries file message
     */
    CANNOT_UPLOAD_GEOMETRIES_FILE = 'error_cannotUploadGeometriesFile',
    /**
     * Cannot upload requested file
     */
    CANNOT_UPLOAD_REQUESTED_FILE = 'error_cannotUploadRequestFile',
    /**
     * Cannot validate dossier message
     */
    CANNOT_VALIDATE_DOSSIER = 'error_cannotValidateDossier',
    /**
     * Cannot load available languages from configuration
     */
    CONFIGURATION_AVAILABLE_LANGUAGES = 'configurationAvailableLanguages',
    /**
     * Deleted dossier message
     */
    DELETED_DOSSIER_MESSAGE = 'error_deletedDossierMessage',
    /**
     * Dossier cannot load
     */
    DOSSIERS_CANNOT_LOAD = 'error_dossierCannotLoad',
    /**
     * Egov authentication message
     */
    EGOV_REQUIRED = 'error_egovRequired',
    /**
     * Language not set message
     */
    LANGUAGE_NOT_SET = 'error_languageNotSet',
    /**
     * Loaded dossier messsage
     */
    LOADED_DOSSIER_MESSAGE = 'error_loadedDossierMessage',
    /**
     * Max file upload reached message
     */
    MAX_FILE_UPLOAD_REACHED = 'error_maxFileUploadReached',
    /**
     * Not exists geometries uploaded before
     */
    NOT_EXISTENT_GEOMETRIES = 'error_not_existent_geometries',
     /**
     * Not exists norme uploaded before
     */
    NOT_EXISTENT_NORME = 'error_not_existent_norme',
     /**
     * Not exists other uploaded before
     */
    NOT_EXISTENT_OTHER = 'error_not_existent_other',
    /**
     * Not valid file extension 
     */
    NOT_VALID_FILE_EXTENSION = 'error_notValidFileExtension',
    /**
     * Not valid language message
     */
    NOT_VALID_LANGUAGE = 'error_notValidLanguage',
    /**
     * No ambiti for plan selected message
     */
    NO_AMBITI_FOR_PLAN = 'error_noAmbitiForPlan',
    /**
     * The no validation donw
     */
    NO_VALIDATION_DONE = 'error_noValidationDone',
    /**
     * The persistency warning
     */
    PERSISTENCY_WARNING = 'persistency_warning',
    /**
     * Plan types failed message
     */
    PLAN_TYPES_FAILED = 'error_planTypesFail',
    /**
     * Validating dossier message
     */
    VALIDATING_DOSSIER_MESSAGE = 'error_validatingDossierMessage'
}